import { gql, useMutation } from '@apollo/client';
import type { SetLotTransferItemTags, SetLotTransferItemTagsVariables } from 'types/graphql';

export const SET_LOT_TRANSFER_ITEM_TAGS = gql`
  mutation SetLotTransferItemTags($id: Int!, $input: [QuantityForPalletTag!]!) {
    setPalletTagsOnTransferItem(id: $id, palletTags: { quantities: $input }) {
      palletTag { id tagNumber cartonQuantity }
      deletedAt
      quantity
    }
  }
`;
export function useSetLotTransferItemTags() {
  const [setLotTransferItemTags, { loading, error }] = useMutation<
    SetLotTransferItemTags,
    SetLotTransferItemTagsVariables
  >(SET_LOT_TRANSFER_ITEM_TAGS);
  return { setLotTransferItemTags, loading, error };
}
